export default __webpack_public_path__ + "static/media/headphones.ce9d4874.svg";